import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { blob } from 'd3';
import { of } from "rxjs";
import { map, tap } from "rxjs/operators";
interface CachedImage {
  id: string;
  url: string;
  blob: Blob;
}
@Injectable({
  providedIn: 'root'
})
export class CacheImageService {
  private _cacheImages: CachedImage[] = [];
  constructor(private http: HttpClient, private domSanitizer: DomSanitizer,) { }

  getImage(id: string, url: string) {

     

    let cacheImage = this._cacheImages.find(image => image.id == id);
    if (cacheImage != undefined && cacheImage.url == url) {
      return this.convertBlobToSafeUrl(of(cacheImage.blob));
    }
    else if (cacheImage != undefined && cacheImage.url != url) {
      this._cacheImages.splice(this._cacheImages.indexOf(cacheImage), 1)
    }

    var response = this.http.get(url, { observe: 'response', responseType: 'blob' }).pipe(
      tap(blob => this._cacheImages.push({ id: id, url: url, blob: blob.body })),
      map((response: HttpResponse<Blob>) => {
        return response.body
      }));
      return this.convertBlobToSafeUrl(response);
  }

  convertBlobToSafeUrl(blob: any) {
    return blob.pipe(
      map((response: Blob) => {
        return URL.createObjectURL(response)
      }),
      map((unsafeBlobUrl: string) => this.domSanitizer.bypassSecurityTrustUrl(unsafeBlobUrl))
    );;
  }

}
